export type ValuePillar = {
  title: string;
  description: string;
};

export const valuePillars: ValuePillar[] = [
  {
    title: 'Technical Research',
    description: 'Dig into obscure specs, clean up bad drawings, and map out what the build really needs.'
  },
  {
    title: 'Custom Solutions',
    description: 'Design and fabricate tooling, fixtures, and electromechanical assemblies when off the shelf fails.'
  },
  {
    title: 'Small Production Runs',
    description: 'Develop processes for 10 to 100 piece runs where precision matters and big firm overhead does not make sense.'
  }
];
